import { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import useTranslate from "hooks/use-translate-language";

const FileUploader = forwardRef(({ onChange, onRemove }, fileRef) => {
  const translate = useTranslate();
  const handleClick = () => {
    fileRef.current.click();
  };
  const [selectedFile, setSelectedFile] = useState();
  const handleChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (typeof onChange === "function") {
      onChange(event);
    }
  };
  return (
    <>
      {selectedFile ? (
        <div style={{ margin: 5, padding: 5 }}>
          <span>{selectedFile.name}</span>
          <span
            onClick={() => {
              setSelectedFile(undefined);
              fileRef.current.value = "";
              if (typeof onRemove === "function") onRemove(undefined);
            }}
            style={{ color: "red" }}
          >
            {translate("remove")}
          </span>
        </div>
      ) : (
        <Button onClick={handleClick}>{translate("uploadAFile")}</Button>
      )}
      <input
        type="file"
        ref={fileRef}
        onChange={handleChange}
        style={{ display: "none" }}
      />
    </>
  );
});

FileUploader.propTypes = { onChange: PropTypes.func, onRemove: PropTypes.func };

export default FileUploader;
